function getNestedProperty(obj, prop, defaultValue = "") {
    
  for (var i = 0; i < prop.length; i++) {
    if (!obj) {
      return defaultValue;
    }
    if (!obj.hasOwnProperty(prop[i])) {
      return defaultValue;
    }
    obj = obj[prop[i]];
  }
  if(!obj) {
    return defaultValue;
  } else {
    return obj;
  }
}

export default getNestedProperty;